<div class="login flex flex-col justify-center items-center">
  <div class="content rounded-lg w-fit p-4">
    <div class="leftcontent bg-transparent">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- <div
    class="sm:hidden md:block relative w-1/2 h-svh flex-auto items-center justify-center dark:border-l lg:px-28 overflow-hidden">
    <img src="assets/loginScreen/loginBanner.svg" width="100%" alt="" />
  </div>
</div> -->
</div>
<span
  class="text-slate-400 flex justify-center items-center gap-2 ">
  <div class="hover:fill-primary">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor">
      <path d="M160-120v-480l320-240 320 240v480H560v-280H400v280H160Z" />
    </svg>
  </div>
  <span class="hover:text-primary cursor-pointer">
    <a href="https://writemed.ai/">Go Home</a>
  </span>
</span>
